import { BASE_URL } from "../../config";
import axiosInstance from "../Interceptors/ResponseInterceptor";

export async function getStagesByPartnerId(partnerId) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}/api/stage-master/stage/partnerid/${partnerId}`
      );
      resolve(response.data);
    } catch (error) {
      console.error("Error in getting stages by partner id:", error);
      reject(error);
    }
  });
}
